export default {
  homeValue: {
    default: 350000,
    min: 1,
    max: 99999999
  },
  firstMortgageBalance: {
    default: 100000,
    min: 1,
    max: 99999999
  },
  homeEquityLoanBalance: {
    default: 50000,
    min: 0,
    max: 99999999
  },
  lienBalance: {
    default: 15000,
    min: 0,
    max: 99999999
  }
}
